import { data } from "react-router";
import { API_URLs } from "../../../utilities/API_URLs";
import iAxios from "../../../utilities/axios/axios-setup";
import { Http } from "../../../utilities/axios/http";
import { StoragePageState } from "./_model";
// import { NewRoleData, UserRolePageState } from "./_model"

export const postNewStorge = (data: any) => {
  return iAxios
    .post(API_URLs.settings.users.postUser, data)
    .then((r) => {
      return r.data;
    })
    .catch((e) => {
      return null;
    });
};

export const getUserStorage = (pageState: StoragePageState) => {
  const obj: any = { ...pageState, order: null };
  Object.keys(pageState).forEach((key: any) => {
    if (key === "order") {
      console.log("The order key ");
      obj["order[" + (pageState?.order?.dataKey ?? "") + "]"] =
        pageState?.order?.order;
    } else {
      obj[key] = obj[key]?.toString();
    }
  });
  delete obj["order"];
  console.log("List page state : ", obj);
  return iAxios
    .get(
      API_URLs.settings.storages.getStorages + "?" + new URLSearchParams(obj)
    )
    .then((r) => {
      return r?.data;
    })
    .catch((e) => {
      return null;
    });
};

export const getStorageById = (id: string) => {
  return iAxios
    .get(API_URLs.settings.users.getUserById?.replace("{id}", id))
    .then((r) => {
      return r.data;
    })
    .catch((e) => {
      return null;
    });
};

export const deleteStorageById = (id: string) => {
  return iAxios
    .delete(API_URLs.settings.users.deleteUserById?.replace("{id}", id))
    .then((r) => {
      return r.data;
    })
    .catch((e) => {
      return null;
    });
};

export const patchStorageById = (id: string, data: any) => {
  return iAxios
    .patch(
      API_URLs.settings.users.patchUserById?.replace("{id}", id),
      { ...data, id },
      {
        headers: {
          "Content-Type": "application/merge-patch+json",
        },
      }
    )
    .then((r) => {
      return r.data;
    })
    .catch((e) => {
      return null;
    });
};

export class StorageService {
  static getStorageList = async (params?: any) => {
    try {
      return await Http.get(API_URLs.settings.storages.getStorages, params);
    } catch (error) {
      return error;
    }
  };

  static getStorageHistoryList = async (params?: any) => {
    try {
      return await Http.get(API_URLs.settings.storages.historyList, params);
    } catch (error) {
      return error;
    }
  };

  static getStorageDetailHistoryList = async (params?: any) => {
    try {
      return await Http.get(API_URLs.settings.storages.historyDetail, params);
    } catch (error) {
      return error;
    }
  };

  static getStorageById = async (id: number) => {
    try {
      return await Http.get(`${API_URLs.settings.storages.storageUrl}/${id}`);
    } catch (error) {
      return error;
    }
  };

  static getStorageLoadStateSelect = async (params?: any) => {
    try {
      return await Http.get(API_URLs.settings.storages.stateSelect, params);
    } catch (error) {
      return error;
    }
  };

  // =============== STORAGE LOADS LIST =================
  static getStorageLoadList = async (params?: any) => {
    try {
      return await Http.get(API_URLs.settings.storages.storageLoads, params);
    } catch (error) {
      return error;
    }
  };

  static getStorageLoadById = async (id: number) => {
    try {
      return await Http.get(`${API_URLs.settings.storages.storageLoads}/${id}`);
    } catch (error) {
      return error;
    }
  };

  static createStorageLoad = async (data: any) => {
    try {
      return await Http.post(API_URLs.settings.storages.storageLoads, data);
    } catch (error) {
      return error;
    }
  };

  static updateStorageLoad = async (data: any) => {
    try {
      return await Http.patch(API_URLs.settings.storages.storageLoads, data);
    } catch (error) {
      return error;
    }
  };

  static importGateInFile = async (data: any) => {
    try {
      return await Http.post(API_URLs.settings.storages.importGateIn, data);
    } catch (error) {
      return error;
    }
  };
}
